<script lang="ts">
  import type { EmptyContent } from "$lib/elev8Api/contentTypes";
  import { logger } from "$lib/utils/logger";

  interface Props {
    content: EmptyContent;
  }

  const { content }: Props = $props();
  logger.info(
    `[EmptyContent] Rendering empty content with type: ${() => content.content_type}`
  );
</script>

<!-- This page intentionally left blank -->
